<template>
  <bookings-list />
</template>

<script>
import BookingsList from "@/components/3pl/Operations/Bookings/BookingsList.vue";
export default {
  components: {
    BookingsList,
  },
};
</script>

<style></style>
